<template>
  <div class="p-fluid">
    <div class="card">
      <h5 class="p-text-center">Edición de usuario</h5>
      <form @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="p-field">
          <label
            for="userName"
            :class="{ 'p-error': v$.userName.$invalid && submitted }"
            >User Name*</label
          >
          <InputText
            id="userName"
            v-model="v$.userName.$model"
            :class="{ 'p-invalid': v$.userName.$invalid && submitted }"
          />
          <small
            v-if="
              (v$.userName.$invalid && submitted) ||
                v$.userName.$pending.$response
            "
            class="p-error"
            >{{ v$.userName.required.$message.replace('Value', 'Name') }}</small
          >
        </div>

        <div class="p-field">
          <label for="empresa">Empresa</label>
          <Dropdown
            id="empresa"
            v-model="v$.empresa.$model"
            :options="empresas"
            optionLabel="name"
            placeholder="Select Empresa"
          ></Dropdown>
        </div>

        <div class="p-field">
          <label
            for="email"
            :class="{ 'p-error': v$.email.$invalid && submitted }"
            >Email*</label
          >
          <InputText
            id="email"
            v-model="v$.email.$model"
            :class="{ 'p-invalid': v$.email.$invalid && submitted }"
          />
          <small
            v-if="
              (v$.email.$invalid && submitted) || v$.email.$pending.$response
            "
            class="p-error"
            >{{ v$.email.required.$message.replace('Value', 'Email') }}</small
          >
        </div>

        <div class="p-field-checkbox">
          <InputSwitch id="active" v-model="v$.active.$model" />
          <label class="p-label" for="active">Activo</label>
        </div>

        <h5>Roles</h5>
        <MultiSelect
          v-model="v$.selectedRoles.$model"
          :options="roles"
          optionValue="name"
          optionLabel="name"
          placeholder="Seleccione los roles del usuario"
        />

        <!--
                    
                    <Listbox v-model="selectedRoles" 
                         :options="roles" 
                         :multiple="true" 
                         :filter="true" 
                         optionLabel="name" 
                         optionValue="name"
                         listStyle="max-height:250px" 
                         style="width:15rem" 
                         filterPlaceholder="Buscar">
                    <template #option="slotProps">
                        <div class="roles-item">
                            <div>{{slotProps.option.name}}</div>
                        </div>
                    </template>
                </Listbox>
                -->
        <br />
        <div class="p-d-flex p-jc-center">
          <div class="p-mr-2"><Button type="submit" label="Guardar" /></div>
          <router-link to="/plantillas">
            <div class="p-mr-2"><Button type="button" label="Cancel" /></div>
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPut } from '../../helpers/rest-api';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      id: '',
      empresas: [],
      roles: [],
      selectedRoles: [],
      empresa: null,
      userName: '',
      email: '',
      active: false,
      submitted: false,
    };
  },
  validations() {
    return {
      userName: {
        required,
      },
      empresa: {
        required,
      },
      email: {
        required,
      },
      selectedRoles: {
        required,
      },
      active: {
        required: false,
      },
    };
  },
  mounted() {
    this.getEmpresas();

    this.getRoles();

    this.getId(this.$router.currentRoute.value.params.id);
  },

  methods: {
    getEmpresas() {
      apiGet('empresa').then((response) => (this.empresas = response.data));
    },

    getRoles() {
      apiGet('rol').then((response) => (this.roles = response.data));
    },

    getId(id) {
      apiGet(`user/${id}`).then(
        (response) => (
          (this.userName = response.data.userName),
          (this.id = response.data.id),
          (this.empresa = response.data.empresa),
          (this.email = response.data.email)
        )
      );
      apiGet(`user/${id}/roles`).then(
        (response) => (this.selectedRoles = response.data.map((e) => e))
      );
    },

    handleSubmit() {
      this.submitted = true;
      const { userName, empresa, email, selectedRoles, id } = this;

      apiPut(
        `user/${id}`,
        JSON.stringify({ userName, empresa, email, roles: selectedRoles })
      ).then(() => this.$router.push('/usuarios'));
    },
  },
};
</script>
